import { render, staticRenderFns } from "./SupplierSettingsSubscriptionTab.vue?vue&type=template&id=c45a117a&"
import script from "./SupplierSettingsSubscriptionTab.vue?vue&type=script&lang=js&"
export * from "./SupplierSettingsSubscriptionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports